/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { FirmwareState } from './models';
import { FirmwareUpdateResult } from './models';
import { CrcCheckBodyConverter } from './converters';

export const firmwareState = createEnumConverter<FirmwareState>(
  FirmwareState,
  1,
);

export const firmwareStateArray = createEnumArrayConverter<FirmwareState>(
  FirmwareState,
  1,
);

export const firmwareUpdateResult = createEnumConverter<FirmwareUpdateResult>(
  FirmwareUpdateResult,
  1,
);

export const firmwareUpdateResultArray =
  createEnumArrayConverter<FirmwareUpdateResult>(FirmwareUpdateResult, 1);

export const crcCheckBody = new CrcCheckBodyConverter();
